import { Anchor } from '@components/anchor'
import { Text } from '@components/text'
import { getSlugFromString } from '@lib/utils/getSlugFromString'
import type { GreenHouseDepartment } from '@server/helpers/greenhouse'
import { LINK } from '@shared/util/link'
import classNames from 'classnames'
import { useRouter } from 'next/router'
import type { FunctionComponent } from 'react'

import styles from './greenhouse.module.scss'

export const GreenHouseBoard: FunctionComponent<Props> = ({
    departments = [],
}) => <div className={styles.board}>{departments.map(renderDepartment())}</div>

const Department: FunctionComponent<GreenHouseDepartment> = ({
    name,
    jobs,
    children,
    depth = 0,
}) => {
    const router = useRouter()

    return (
        <div
            className={classNames(styles.department, {
                [styles.nested]: depth,
            })}
        >
            <Text
                tag='h4'
                bold
                color='white'
                typeStyle='heading-xs'
                className={classNames(styles['department-heading'])}
            >
                {name}
            </Text>

            {jobs.map(({ id, title }) => {
                const link = LINK.job(getSlugFromString(title))

                return (
                    <Anchor
                        key={id}
                        as={link.serialize(router)}
                        href={link.route}
                    >
                        <Text
                            tag='span'
                            typeStyle='body-sm'
                            className={styles['job-title']}
                        >
                            {title}
                        </Text>
                    </Anchor>
                )
            })}

            {children.map(renderDepartment(depth + 1))}
        </div>
    )
}

const renderDepartment =
    (depth?: number) =>
    ({ name, jobs, children }: GreenHouseDepartment) =>
        jobs.length ? (
            <Department key={name} depth={depth} name={name} jobs={jobs}>
                {children}
            </Department>
        ) : null

interface Props {
    departments: GreenHouseDepartment[]
}
